<div class="container">
  <h1>
    @if (meetingInfo?.MeetingName) {
      <span>
        {{ meetingInfo?.ProjectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>

  @if (meetingInfo?.MeetingName) {
    <h3>Register for {{ meetingInfo?.MeetingName }}</h3>
  }

  <div class="step">
    <p>Please enter your information to register.</p>
  </div>

  @if (!registrationForm.value['IsAnonymous']) {
    <app-global-search-stakeholder
      (formResult)="handleStakeholderSearchResult($event)"
      (formValidity)="handleFormValidity($event)"
      [emitOnSubmit]="onStakeholderSearch"
      [removeOnBlur]="true"
    ></app-global-search-stakeholder>
  }

  <form [formGroup]="registrationForm" aria-label="Online Meeting Registration Form" class="meeting-registration-form">
    @if (meetingInfo?.AllowAnonAttendees) {
      <mat-checkbox [formControlName]="'IsAnonymous'" [aria-label]="'Register as anonymous'">
        Register as anonymous
      </mat-checkbox>
    }

    <mat-checkbox [formControlName]="'IsMultipleAttending'"> Are you registering multiple people? </mat-checkbox>

    @if (registrationForm.value['IsMultipleAttending']) {
      <div class="number-incrementor-container" aria-live="polite" role="region">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label id="additionalAttendeesLabel">Additional Attendees</mat-label>
          <mat-hint id="attendeeHint" class="sr-only">Enter the number of additional attendees.</mat-hint>
          <input
            type="number"
            id="additionalAttendees"
            matInput
            [formControlName]="'ExtraAttendees'"
            [min]="0"
            aria-labelledby="additionalAttendeesLabel"
            aria-describedby="attendeeHint"
          />
        </mat-form-field>
      </div>
    }
  </form>
  <div
    class="button-row"
    [ngClass]="{
      'button-row-margin': !registrationForm.value['IsMultipleAttending'],
    }"
  >
    <button class="blue-button" [class.disabled]="isSubmitDisabled()" (click)="onRegisterForMeeting()">Continue</button>
  </div>
</div>
